import ReactDOM from 'react-dom/client';
import '@sfly/aurora-shared-react-components/styles';
import './styles/styles.css';
import {
  BuilderHeader,
  IDomainPayloadType,
  CartHeader,
  NonNextJSHeaderFullVersion,
  PhotoHeader,
  FooterCart,
  NonNextJSFooterFullVersion,
  DomainBasedBlockComponent,
} from '@sfly/aurora-shared-react-components';
import { addEnvToDomainPayload } from './utils/add-env-to-domainpayload';
import HeaderTimingReporter from './components/header-timing-reporter';

const renderComponent = ({
  elementId,
  componentName,
}: {
  elementId: string;
  componentName: React.ReactElement;
}) => {
  ReactDOM.createRoot(document.getElementById(elementId) as HTMLElement).render(
    componentName,
  );
};

export interface ComponentInputType {
  domainPayload: IDomainPayloadType;
}
// @ts-ignore
window.auroraReactSharedComponent = {
  header: {
    builder: ({ domainPayload }: ComponentInputType) => {
      renderComponent({
        elementId: 'header-root',
        componentName: (
          <>
            <BuilderHeader
              domainPayload={addEnvToDomainPayload(domainPayload)}
            />
            <HeaderTimingReporter
              domainName="BUILDER"
              apiKey={
                domainPayload?.reservedProps?.XApiKey as string | undefined
              }
            />
          </>
        ),
      });
    },
    cart: ({ domainPayload }: ComponentInputType) => {
      renderComponent({
        elementId: 'header-root',
        componentName: (
          <>
            <CartHeader domainPayload={addEnvToDomainPayload(domainPayload)} />
            <HeaderTimingReporter
              domainName="CART"
              apiKey={
                domainPayload?.reservedProps?.XApiKey as string | undefined
              }
            />
          </>
        ),
      });
    },
    shopping: ({ domainPayload }: ComponentInputType) => {
      renderComponent({
        elementId: 'header-root',
        componentName: (
          <>
            <NonNextJSHeaderFullVersion
              domainPayload={addEnvToDomainPayload(domainPayload)}
            />
            <HeaderTimingReporter
              domainName="SHOPPING"
              apiKey={
                domainPayload?.reservedProps?.XApiKey as string | undefined
              }
            />
          </>
        ),
      });
    },
    photos: ({ domainPayload }: ComponentInputType) => {
      renderComponent({
        elementId: 'header-root',
        componentName: (
          <>
            <PhotoHeader domainPayload={addEnvToDomainPayload(domainPayload)} />
            <HeaderTimingReporter
              domainName="PHOTOS"
              apiKey={
                domainPayload?.reservedProps?.XApiKey as string | undefined
              }
            />
          </>
        ),
      });
    },
  },
  footer: {
    cart: ({ domainPayload }: ComponentInputType) => {
      renderComponent({
        elementId: 'footer-root',
        componentName: (
          <FooterCart domainPayload={addEnvToDomainPayload(domainPayload)} />
        ),
      });
    },
    shopping: ({ domainPayload }: ComponentInputType) => {
      renderComponent({
        elementId: 'footer-root',
        componentName: (
          <NonNextJSFooterFullVersion
            domainPayload={addEnvToDomainPayload(domainPayload)}
          />
        ),
      });
    },
  },
  blockRequest: ({ domainPayload }: ComponentInputType) => {
    renderComponent({
      elementId: `${domainPayload?.reservedProps?.elementId}`,
      componentName: (
        <DomainBasedBlockComponent
          domainPayload={addEnvToDomainPayload(domainPayload)}
        />
      ),
    });
  },
};
